/**
 * رابط واتساب الدعم — رقم ورسالة افتراضية من المتغيرات البيئية
 * يستخدم في صفحة الحملات وزر الواتساب العائم (مثلاً في صفحة التسجيل)
 */

const SUPPORT_WHATSAPP_NUMBER =
  process.env.NEXT_PUBLIC_SUPPORT_WHATSAPP || '966500000000';

const SUPPORT_DEFAULT_MESSAGE_ENV =
  process.env.NEXT_PUBLIC_WHATSAPP_SUPPORT_DEFAULT_MESSAGE;

/**
 * يبني رابط wa.me مع رسالة افتراضية اختيارية
 * @param defaultMessage الرسالة الافتراضية (مثلاً من الترجمة). تُتجاهل إذا وُجد NEXT_PUBLIC_WHATSAPP_SUPPORT_DEFAULT_MESSAGE
 */
export function buildSupportWhatsAppUrl(defaultMessage: string): string {
  const base = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;
  const message = SUPPORT_DEFAULT_MESSAGE_ENV?.trim() || defaultMessage;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}
